import Vue from "vue"
import VueI18n from "vue-i18n"
import getLocale from "@/utils/locale"
import BookSlider from "@/features/book-slider/components/book-slider"
import handleCapturedVueError from "@/utils/handle-captured-vue-error"

Vue.use(VueI18n)

const container = document.querySelector(".vue-book-slider")

if (container) {
  const { headline, books } = container.dataset

  const booksJson = JSON.parse(books)

  new Vue({
    name: "BookSliderInit",
    el: container,
    i18n: new VueI18n({ locale: getLocale() }),
    render: (h) =>
      h(BookSlider, {
        props: {
          headline,
          books: booksJson
        }
      }),
    errorCaptured: handleCapturedVueError
  })
}
